import type { DocumentEditOwner } from '../documentOwner';

export type DocumentEditListPath =
  | 'suitability-reports'
  | 'data-exports'
  | 'meeting-agendas'
  | 'meeting-notes';

export function resolveDocumentEditBackHref(
  owner: DocumentEditOwner | null,
  documentTypePath: DocumentEditListPath,
  fromPath?: string,
): string {
  if (fromPath) return fromPath;
  if (owner?.clientId) return `/client/${owner.clientId}/document/${documentTypePath}`;
  if (owner?.familyId) return `/family/${owner.familyId}/documents/${documentTypePath}`;
  return '/clients/all';
}
